// Cookie-notice state.
//
// Analytics (PostHog + Google Analytics) load immediately on page load. This
// module only tracks whether the user has acknowledged the informational
// cookie notice, so we don't show the banner on every visit.

const STORAGE_KEY = 'cvl_cookie_notice';

/** True once the user has dismissed the cookie notice. */
export function isNoticeAcknowledged(): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'dismissed';
    } catch {
        return false;
    }
}

/** Records that the user has seen and dismissed the cookie notice. */
export function acknowledgeNotice(): void {
    try {
        localStorage.setItem(STORAGE_KEY, 'dismissed');
    } catch {
        /* storage unavailable (private mode etc.) — ignore */
    }
}

/**
 * Re-opens the cookie notice. Wire this to a "Cookie notice" link
 * (e.g. in the footer):
 *   import { openCookieSettings } from '.../analytics/consent';
 *   <button onClick={openCookieSettings}>Cookie notice</button>
 */
export function openCookieSettings(): void {
    window.dispatchEvent(new Event('cvl:cookie-settings'));
}
